export const highlightMessage = (convId: string, msgId: string) => {
  const msgDiv = document.getElementById(`${convId}-${msgId}`);
  if (!msgDiv) {
    setTimeout(() => highlightMessage(convId, msgId), 300);
    return;
  }

  msgDiv.classList.add('highlight-animation');
  setTimeout(() => {
    msgDiv.classList.remove('highlight-animation');
  }, 3000);
};
